import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/main.scss';
import App from './App';
import { smartlookIdentify } from './smartlook/identify';

smartlookIdentify();
/* eslint-disable react/no-deprecated */
ReactDOM.render(<App />, document.getElementById('app'));
